"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by andi on 10.01.17.
 */

exports.default = {
  MAX_WIDTH_MOBILE: 768,
  MAX_WIDTH_TABLET: 1280,
  MAX_WIDTH_DESKTOP: 1920
};